<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="产品编码"><el-input v-model="query.materialCode" size="small" clearable style="width:150px" /></el-form-item>
      <el-form-item label="产品名称"><el-input v-model="query.materialName" size="small" clearable style="width:150px" /></el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('inventory:warning:list')" type="primary" size="small" @click="search">查询</el-button>
        <el-button size="small" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="rows" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" align="center" />
      <el-table-column prop="materialCode" label="产品编码" min-width="140" />
      <el-table-column prop="materialName" label="产品名称" min-width="160" />
      <el-table-column prop="specs" label="规格型号" min-width="120" show-overflow-tooltip />
      <el-table-column prop="usableQuantity" label="全仓可用库存" width="130" align="right" />
      <el-table-column prop="safetyQty" label="安全库存" width="110" align="right" />
      <el-table-column prop="warningQuantity" label="预警缺口" width="110" align="right" />
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="v => { pageSize = v; pageIndex = 1; load() }" @current-change="v => { pageIndex = v; load() }" />
  </div>
</template>
<script>
import request from '../../api/request'
import { authMixin } from './inventoryShared'
export default {
  name: 'Warning',
  mixins: [authMixin],
  data() { return { query: { materialCode: '', materialName: '' }, rows: [], pageIndex: 1, pageSize: 20, total: 0, loading: false } },
  created() { this.load() },
  methods: {
    search() { this.pageIndex = 1; this.load() },
    resetQuery() { this.query = { materialCode: '', materialName: '' }; this.search() },
    load() {
      this.loading = true
      request.get('/inventory/warning/list', { params: { materialCode: this.query.materialCode, materialName: this.query.materialName, pageIndex: this.pageIndex, pageSize: this.pageSize } })
        .then(res => {
          const body = res.data || {}
          this.rows = body.list || []
          this.total = body.totalCount || 0
        }).catch(() => { this.rows = []; this.total = 0 }).finally(() => { this.loading = false })
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.code-link { color: #348adb; cursor: pointer; }
.title-actions { float: right; margin-right: 28px; }
.line-tools { margin-bottom: 10px; }
.cards { margin-bottom: 12px; }
.card-num { font-size: 28px; font-weight: 600; margin-top: 8px; }
</style>
